import { Industry } from "models/Company"

type IndustrieListType = {
    industries: Industry[] | undefined,
    mainIndustryCode: string | undefined
}

export default function IndustriesList({ industries, mainIndustryCode }: IndustrieListType) {

    if (industries === undefined) {
        return (<></>)
    }

    const mainIndustry = industries.find(ind => ind.code === mainIndustryCode);
    const additionalIndustries = industries.filter(ind => ind.code !== mainIndustry?.code);

    return (
        <tbody>

            <tr key={"industries_main"}>
                <th>{"Hovedbransje"}</th>
                <td>{mainIndustry?.name ?? "Ikke valgt"}</td>
            </tr>
            {additionalIndustries.map((industry: Industry, index: number) => {
                if (industry.deleted === false) {
                    return (
                        <tr key={"industries_" + index}>
                            <th>{"- Tilleggsbransje"}</th>
                            <td>{industry.name}</td>
                        </tr>
                    )
                }
            })}
        </tbody>
    )
}